import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-king-glow-svg',
  standalone: true,
  template: `
    <svg
      [class.challenger]="isChallenger()"
      width="305"
      height="220"
      viewBox="0 0 305 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g [attr.filter]="'url(#' + filterId() + ')'">
        <path
          [attr.d]="pathD()"
          [attr.fill]="'url(#' + gradientId() + ')'"
          fill-opacity="0.3"
        />
      </g>
      <defs>
        <filter
          [attr.id]="filterId()"
          [attr.x]="filterX()"
          y="-45"
          width="350"
          height="310"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="22.5" result="effect1_foregroundBlur" />
        </filter>
        <linearGradient
          [attr.id]="gradientId()"
          [attr.x1]="gradientCenter()"
          y1="0"
          [attr.x2]="gradientCenter()"
          y2="220"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" [attr.stop-color]="color()" />
          <stop offset="1" stop-color="#161931" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KingGlowSvgComponent {
  readonly isChallenger = input<boolean>(false);

  protected readonly color = computed(() =>
    this.isChallenger() ? '#3888FF' : '#FB5858',
  );

  protected readonly pathD = computed(() =>
    this.isChallenger()
      ? 'M125 0H225L305 220H45L125 0Z'
      : 'M80 0H180L260 220H0L80 0Z',
  );

  protected readonly filterX = computed(() =>
    this.isChallenger() ? 0 : -45,
  );

  protected readonly gradientCenter = computed(() =>
    this.isChallenger() ? 175 : 130,
  );

  protected readonly filterId = computed(() =>
    this.isChallenger() ? 'king_glow_filter_challenger' : 'king_glow_filter_king',
  );

  protected readonly gradientId = computed(() =>
    this.isChallenger() ? 'king_glow_grad_challenger' : 'king_glow_grad_king',
  );
}
